<div class="flex">
  <div
    class="flex text-[13px] font-semibold text-[#203D54] mt-[10px] w-[232px]"
  >
    Project Type
  </div>
  <div class="autocomplete-container">
    <div class="flex justify-start mt-[-13px] pb-[5px]">
      <div
        class="ml-[12px] bg-[#f9dacf] px-[6px] pt-[4px] pb-[4px] rounded-[50%] flex justify-end items-center"
      >
        <img
          src="assets/icons/close.svg"
          alt="close"
          class="cursor-pointer w-[14px]"
          (click)="cancel()"
        />
      </div>
      <div class="ml-[12px] bg-[#f9dacf] p-[4px] rounded-[50%]">
        <img
          src="assets/icons/save.svg"
          alt="save"
          class="cursor-pointer w-[20px] pr-[2px]"
          (click)="save()"
        />
      </div>
    </div>
    <!-- <input
      #mainProjectType
      matInput
      [value]="projectType"
      placeholder="Select Project Type "
      [formControl]="projectTypeControl"
      (focus)="onFocusMainProjectType()"
      (blur)="onBlurMainProjectType()"
      style="
        border-radius: 10px;
        border: 1px solid #1a4971;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        background-color: inherit;
        height: 41px;
        padding-left: 7px;
        width: 279px;
        font-size: 13px;
      "
    /> -->
    <mat-form-field appearance="outline">
      <mat-label>Select Project Type</mat-label>
      <input
        #mainProjectType
        matInput
        [value]="projectType"
        [formControl]="projectTypeControl"
        (focus)="onFocusMainProjectType()"
        (blur)="onBlurMainProjectType()"
      />
    </mat-form-field>
    

    <div class="dropdown" *ngIf="showDropdownMainProjectType">
      <ng-container *ngIf="parants[0]?.length > 0">
        <div *ngFor="let parent of parants[0]">
          <div
            (click)="onSelectionMainProjectType(parent?.name, parent?.id)"
            class="dropdown-item"
            style="cursor: pointer"
          >
            {{ parent?.name }}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div
  class="flex mt-[15px] mb-[9px]"
  *ngIf="childs[0] && childs[0]?.length > 0 && projectSubType"
>
  <div
    class="flex text-[13px] font-semibold text-[#203D54] mt-[10px] w-[232px]"
  >
    Project Sub Type
  </div>
  <div class="autocomplete-container">
   <mat-form-field appearance="outline">
  <mat-label>Select Project Sub Type</mat-label>
  <input
    #subProjectType
    matInput
    [value]="projectSubType"
    [formControl]="projectSubTypeControl"
    (focus)="onFocusDropdownSubProjectType()"
    (blur)="onBlurDropdownSubProjectType()"
  />
</mat-form-field>


    <div class="dropdown" *ngIf="showDropdownSubProjectType">
      <ng-container *ngIf="childs[0]?.length > 0">
        <div *ngFor="let child of childs[0]">
          <div
            (click)="onSelectionSubProjectType(child?.name, child?.id)"
            class="dropdown-item"
            style="cursor: pointer"
          >
            {{ child?.name }}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<div class="flex mt-[21px]" *ngIf="selectedType === 'Custom'">
  <div
    class="flex text-[13px] font-semibold text-[#203D54] mt-[10px] w-[232px]"
  >
    Select Parent
  </div>
  <div class="autocomplete-container">
    <input
      #customparent
      matInput
      [value]="customParent"
      placeholder="Select Parent"
      [formControl]="projectTypeControl"
      (focus)="onFocusCustomParent()"
      (blur)="onBlurCustomParent()"
      style="
        border-radius: 10px;
        border: 1px solid #1a4971;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        background-color: inherit;
        height: 41px;
        padding-left: 7px;
        width: 279px;
        font-size: 13px;
      "
    />

    <div class="dropdown" *ngIf="customParantShowDropdown">
      <ng-container *ngIf="parants[0]?.length > 0">
        <div *ngFor="let parent of parants[0]">
          <div
            (click)="onSelectionCustomParent(parent?.name, parent?.id)"
            class="dropdown-item"
            style="cursor: pointer"
          >
            {{ parent?.name }}
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>
<form [formGroup]="form">
  <div class="flex items-center mt-[18px]" *ngIf="selectedType === 'Custom'">
    <label
      for="customType"
      class="section-label-sm font-semibold text-[#203D54] w-[108px]"
    >
      Custom Type
    </label>
    <input
      type="text"
      id="customType"
      formControlName="customType"
      class="section-input pl-[12px] mt-1 h-[41px] p-2 block sm:text-sm w-[279px]"
      placeholder="Enter Custom Type"
    />
  </div>
</form>
